import React, { FC, useEffect, useState } from "react";
import { API_URL } from "../../../actions/settings";
import DataTable from 'react-data-table-component';
import { IonButton, IonIcon, IonSpinner } from "@ionic/react";
import { gitPullRequestSharp } from "ionicons/icons";
import NotificationPopUp from "../../extras/NotificationPopUp";
import { useAppSelector } from "../../../Hooks";
import { selectUser } from "../../../reducers/UserReducer";
import { isStaff } from "../../extras/Functions";

interface IProps {
    id:string
};

async function pullData(
  token: string,
  id: string,
) {
  return fetch(`${API_URL}/energystar/property/${id}/pull_meter_estar_data`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then(async (res: any) => {
    if (res.ok) {
      NotificationPopUp("success","Meter Data Pulled From Energy Star")
      return true
    } else {
      const data = await res.json();
      return {
        error: data.error,
      };
    }
  });
}

async function getMeters(token: string, id: string,type:string) {
  return fetch(`${API_URL}/buildings/${id}/${type}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) =>
    res.json());
}

const MeterListTable:FC<IProps> = ({id}) => {
    let params = new URLSearchParams(window.location.search);
    const [data,setData] = useState([])
    const [error,setError] = useState(null)
    const [loading, setLoading] = useState(false)
    const user = useAppSelector(selectUser)
    const [tab,setTab] = useState<string | null>(null)
    const url_tab = params.get("m");

  
    

    const copyUUID = (id:string) => {
        navigator.clipboard.writeText(id);
        const popup = document.getElementById(`copy-${id}`);
        popup?.classList.toggle("show");
        setTimeout(() => {
          const popup = document.getElementById(`copy-${id}`);
          popup?.classList.toggle("show");
        }, 3000);
      };


    useEffect(() => {
    const handleData = async () => {
      const token = `Token ${(localStorage.getItem("token") || "").slice(1,-1)}`;
      const type = tab === 'estar' ? 'meters' : 'internal_meters'
      const res = await getMeters(token, id, type);
      if(res.error){
        setError(res.error)
      }
      else setData(res.data)
    };
    if(tab){
      handleData();
    }
  }, [id,tab]);

  useEffect(()=>{
      if (url_tab && url_tab === 'internal'){
        setTab(url_tab)
        const button = document.querySelector(`#${url_tab}_meters_button`)
        button?.classList.add('selected')
      }else{
        setTab('estar')
        const button = document.querySelector(`#estar_meters_button`)
        button?.classList.add('selected')
      }
    },[url_tab])

  const handleMenuClick = (e:any, tab:string) => {
    setTab(tab)
    const buttons: NodeListOf<Element>  = document.querySelectorAll(".meters-menu-button")
    buttons.forEach((button:any)=>{
        button.classList.remove('selected')
    })
    e.target.classList.add('selected')
  }


  const handlePullData = async () => {
    setLoading(true)
      const token = `Token ${(localStorage.getItem("token") || "").slice(1,-1)}`;
      const res = await pullData(token, id);
      setLoading(false);
      if (res){
        window.location.href=`/?id=${id}&sec=buildings&t=meters`;
      }
    };

  const columns = [
        {
            name: 'Name',
            selector: (row:any) => {

                return <div>
                    <a href={`/energystar/meters/${row.id}`}><span style={{fontWeight:'bold', color:'white',textDecoration:'underline',textDecorationColor:'white'}}>{row.name}</span></a>
                    <div style={{fontSize:'smaller'}}>{row.meter_id}</div>
                </div> 
            },
            sortable: true,
        },
        {
            name: 'Meter Type',
            selector: (row:any) => {

                return row.type.name
            },
            sortable: true,
        },
        {
            name: 'In Use?',
            selector: (row:any) => {
                
                if(row.inuse){
                    return "Active"
                }
                else{
                    const date = new Date(row.inactivedate)
                    const full_date =  `${date.getUTCMonth()+1}/${date.getUTCDate()}/${date.getUTCFullYear()}`
                    return <div>
                        <div>Not in Use</div>
                        <div>({full_date})</div>
                    </div>
                }
            },
            sortable: false,
        },
        {
            name: 'Latest Bill Date',
            selector: (row:any) => {
                const date = new Date(row.latest_bill_date)
                return `${date.getUTCMonth()+1}/${date.getUTCDate()}/${date.getUTCFullYear()}`
            },
            sortable: false
        },
        {
            name: 'Cost Avoidance Method',
            selector: (row:any) => row.baseline_adjustment_method.name,
            sortable: false,
        },
    ];

    const internal_meters_columns = [
        {
          name: 'ID',
          selector: (row:any) => {

            return <div style={{fontSize:'smaller',display:'flex',alignItems:'center'}}>
              <span className="popup">
              <span className="popuptext" id={`copy-${row.id}`}>
                    Copied
                  </span>
              <IonButton size="small" fill="clear" style={{color:'white',fontSize:'10px'}} onClick={() => copyUUID(row.id)}>
                <div>{row.id}</div>
              </IonButton>
              </span>
              
              </div>
          },
        },
        {
            name: 'Name',
            selector: (row:any) => {

                return <div>
                    <span style={{fontWeight:'bold', color:'white'}}>{row.name}</span>
                    <div style={{fontSize:'smaller'}}>{row.meter_id}</div>
                </div> 
            },
            sortable: true,
        },
        {
            name: 'Meter Type',
            selector: (row:any) => {

                return row.type.name
            },
            sortable: true,
        },
        {
            name: 'Units',
            selector: (row:any) => {

                return <div>{row.unitofmeasure}</div>
            },
            sortable: true,
        },
        {
            name: 'Delete',
            selector: (row:any) => {
                return <IonButton size="small" color="danger" fill="clear" onClick={async()=>{
                    const token = `Token ${(localStorage.getItem("token") || "").slice(1,-1)}`;
                    const res = await fetch(`${API_URL}/buildings/meter/${row.id}`,{
                        method:"DELETE",
                        headers:{
                            "Content-Type":"application/json",
                            "Accept":"application/json",
                            "Authorization": token
                        }
                    }).then(res=>res.json())
                    if(res.error){
                        NotificationPopUp("error",res.error)
                    }
                    else{
                        NotificationPopUp("success","Meter Deleted")
                        window.location.href=`/?id=${id}&sec=buildings&t=meters&m=internal`;
                    }
                }}>Delete</IonButton>
            },
            button: true,
            omit: !isStaff(user)

        }
      ]

    const noMeters = <div>
            <div>{error}</div>
            {isStaff(user) ?
            <div>
            <div>
              Click Button to Pull Meter Data From Energy Star.</div>
            <IonButton size="small" color="medium" disabled={loading} title="Pull Meter Data" onClick={()=>handlePullData()}>
                {loading ? <IonSpinner /> : <IonIcon src={gitPullRequestSharp}/>}
            </IonButton>
            </div> : null
            }
        </div>

    const title = tab === 'estar' ? <div style={{display:'flex',justifyContent:'space-between'}}>
            <div>Meters</div>
            {isStaff(user) ? 
            <IonButton size="small" color="medium" disabled={loading} title="Pull Meter Data" onClick={()=>handlePullData()}>
                {loading ? <IonSpinner /> : <IonIcon src={gitPullRequestSharp}/>}
            </IonButton>: null
            }
        </div> : <div style={{display:'flex',justifyContent:'space-between'}}>
            <div>Internal Meters</div>
            {isStaff(user) ? 
            <IonButton size="small" color="medium" disabled={loading} title="Add Meter" href={`/building/${id}/meters`}>
                {loading ? <IonSpinner /> : "Add Meter"}
            </IonButton>: null
            }
        </div>


    
    return <div style={{marginBottom:'12rem'}}>
      { isStaff(user) ?
      <div style={{display:'flex',justifyContent:'center',marginBottom:'0.5rem',marginTop:'0.5rem'}}>
        <div style={{borderBottom:'1px solid white'}}>
        <IonButton id='estar_meters_button' 
        className= { tab === 'estar' ?  "selected meters-menu-button" : 'meters-menu-button'}
        fill='clear' color="light" 
        onClick={(e)=>handleMenuClick(e,'estar')}>Utility Meters</IonButton>
        <IonButton id='internal_meters_button' className={ tab === 'internal' ?  "selected meters-menu-button" : 'meters-menu-button'} fill='clear' color="light" onClick={(e)=>handleMenuClick(e,'internal')}>Internal Meters</IonButton>                
      </div>
      </div> : null }
      { error && tab=== 'estar' ? noMeters :
      <DataTable
          title={title}
          columns={tab === 'estar' ? columns : internal_meters_columns}
          data={data}
          pagination
          theme='dark'

        /> }
        </div>
};

export default MeterListTable;